import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { getMyLevels } from '../api/levels';
import { getLevelDef } from '../constants/levels';
import { useTranslation } from '../i18n';
import { DirectionalIcon } from './ui/DirectionalIcon';

/**
 * Slim tappable entry point to the level ladder — sits below the header on
 * Home. Deliberately quiet: a small pill, not a card competing with the
 * primary utility actions. See the placement brainstorm — the stats row
 * stays pure "live building status" and the quick-actions grid stays pure
 * utility, so this lives in its own row instead of folding into either.
 */
export function LevelBanner() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { data } = useQuery({
    queryKey: ['levels'],
    queryFn:  () => getMyLevels().then((r) => r.data.data),
    staleTime: 60_000,
  });

  if (!data || data.currentLevel === 0) return null;

  const def = getLevelDef(data.currentLevel);
  if (!def) return null;

  return (
    <button
      onClick={() => navigate('/levels')}
      style={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        width: '100%', background: 'var(--primary-container)', border: 'none',
        borderRadius: '14px', padding: '10px 14px', marginBottom: '14px', cursor: 'pointer',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <span className="material-symbols-outlined" style={{ fontSize: '18px', color: 'var(--primary)' }}>
          {def.icon}
        </span>
        <span style={{ fontFamily: 'var(--manrope)', fontSize: '13px', fontWeight: 700, color: 'var(--primary)' }}>
          {t('level_banner_label').replace('{title}', t(def.titleKey))}
        </span>
      </div>
      <DirectionalIcon icon="chevron_right" style={{ fontSize: '16px', color: 'var(--primary)' }} />
    </button>
  );
}
